/* global axios */

const knowledgeProxy = (accountId, path) =>
  `/api/v1/accounts/${accountId}/proxy/knowledge${path}`;

export const state = {
  hours: [],
  overrides: [],
  loading: false,
  saving: false,
  error: null,
  overridesLoading: false,
  overridesSaving: false,
  overridesError: null,
}

export const getters = {
  all: (state) => state.hours,
  isLoading: (state) => state.loading,
  isSaving: (state) => state.saving,
  error: (state) => state.error,
  allOverrides: (state) => state.overrides,
  isOverridesLoading: (state) => state.overridesLoading,
  isOverridesSaving: (state) => state.overridesSaving,
  overridesError: (state) => state.overridesError,
}

export const mutations = {
  SET_HOURS(state, payload) { state.hours = payload; },
  SET_LOADING(state, value) { state.loading = value; },
  SET_SAVING(state, value) { state.saving = value; },
  SET_ERROR(state, error) { state.error = error; },
  SET_OVERRIDES(state, payload) { state.overrides = payload; },
  SET_OVERRIDES_LOADING(state, value) { state.overridesLoading = value; },
  SET_OVERRIDES_SAVING(state, value) { state.overridesSaving = value; },
  SET_OVERRIDES_ERROR(state, error) { state.overridesError = error; },
}

export const actions = {
  async fetchOperatingHours({ commit }, { accountId, branchId }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);

    try {
      const { data } = await axios.get(
        knowledgeProxy(accountId, `/v2/accounts/${accountId}/branches/${branchId}/operating-hours`)
      );
      commit('SET_HOURS', data);
      return data;
    } catch (error) {
      commit('SET_ERROR', error.response?.data || error.message);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async updateOperatingHours({ commit, dispatch }, { accountId, branchId, payload }) {
    commit('SET_SAVING', true);
    commit('SET_ERROR', null);

    try {
      const { data } = await axios.put(
        knowledgeProxy(accountId, `/v2/accounts/${accountId}/branches/${branchId}/operating-hours`),
        payload
      );
      commit('SET_HOURS', data);
      dispatch('fetchOperatingHours', { accountId, branchId });
      return data;
    } catch (error) {
      commit('SET_ERROR', error.response?.data || error.message);
      throw error;
    } finally {
      commit('SET_SAVING', false);
    }
  },

  async fetchOverrides({ commit }, { accountId, branchId }) {
    commit('SET_OVERRIDES_LOADING', true);
    commit('SET_OVERRIDES_ERROR', null);

    try {
      const { data } = await axios.get(
        knowledgeProxy(accountId, `/v2/accounts/${accountId}/branches/${branchId}/operating-hours/overrides`)
      );
      commit('SET_OVERRIDES', data);
      return data;
    } catch (error) {
      commit('SET_OVERRIDES_ERROR', error.response?.data || error.message);
      throw error;
    } finally {
      commit('SET_OVERRIDES_LOADING', false);
    }
  },

  async createOverride({ commit, dispatch }, { accountId, branchId, payload }) {
    commit('SET_OVERRIDES_SAVING', true);
    commit('SET_OVERRIDES_ERROR', null);

    try {
      const { data } = await axios.post(
        knowledgeProxy(accountId, `/v2/accounts/${accountId}/branches/${branchId}/operating-hours/overrides`),
        payload
      );
      dispatch('fetchOverrides', { accountId, branchId });
      return data;
    } catch (error) {
      commit('SET_OVERRIDES_ERROR', error.response?.data || error.message);
      throw error;
    } finally {
      commit('SET_OVERRIDES_SAVING', false);
    }
  },

  async updateOverride({ commit, dispatch }, { accountId, branchId, overrideId, payload }) {
    commit('SET_OVERRIDES_SAVING', true);
    commit('SET_OVERRIDES_ERROR', null);

    try {
      const { data } = await axios.patch(
        knowledgeProxy(accountId, `/v2/accounts/${accountId}/branches/${branchId}/operating-hours/overrides/${overrideId}`),
        payload
      );
      dispatch('fetchOverrides', { accountId, branchId });
      return data;
    } catch (error) {
      commit('SET_OVERRIDES_ERROR', error.response?.data || error.message);
      throw error;
    } finally {
      commit('SET_OVERRIDES_SAVING', false);
    }
  },

  async deleteOverride({ commit, dispatch }, { accountId, branchId, overrideId }) {
    commit('SET_OVERRIDES_SAVING', true);
    commit('SET_OVERRIDES_ERROR', null);

    try {
      await axios.delete(
        knowledgeProxy(accountId, `/v2/accounts/${accountId}/branches/${branchId}/operating-hours/overrides/${overrideId}`)
      );
      dispatch('fetchOverrides', { accountId, branchId });
    } catch (error) {
      commit('SET_OVERRIDES_ERROR', error.response?.data || error.message);
      throw error;
    } finally {
      commit('SET_OVERRIDES_SAVING', false);
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
